import Head from 'next/head';
import InviteSegmentJoiner from '@/components/home/InviteSegmentJoiner';
import { PostHogIdentifyWrapper } from '@/components/PostHogIdentifyWrapper';
import { useBrand } from '@/contexts/brand/BrandContext';
import { useBrandUrlSync } from '@/hooks/useBrandUrlSync';

const DefaultHead = () => {
  const { brand } = useBrand();
  useBrandUrlSync();
  const title =
    brand?.brandConfig?.programTitle || brand?.brandConfig?.brandTitle || brand?.brandName || 'Advocacy Program';
  const favicon = brand?.brandConfig?.favicon || brand?.brandConfig?.icon || brand?.brandConfig?.colorBrandLogo || null;

  return (
    <Head>
      <title>{title}</title>
      {favicon && <link rel="icon" href={favicon} />}
    </Head>
  );
};

type GlobalSideEffectsProps = {
  authenticated?: boolean;
};

// gloss
export const GlobalSideEffects = ({ authenticated = false }: GlobalSideEffectsProps) => (
  <>
    <DefaultHead />
    <PostHogIdentifyWrapper />
    {authenticated && <InviteSegmentJoiner />}
  </>
);
